import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.semikong.evaluation');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-semikong-evaluation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.semikong.evaluation/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
}

.semikong-page {
  min-width: 320px;
}

.result-detail-layer {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.result-detail-backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(2, 6, 23, 0.42);
  backdrop-filter: blur(1px);
}

.result-detail-panel {
  z-index: 1;
}

table th,
table td {
  white-space: nowrap;
}

button:focus-visible,
select:focus-visible,
a:focus-visible {
  outline: 2px solid #8b5cf6;
  outline-offset: 2px;
}`],
})
export class PageSemikongEvaluationComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public scopeOptions: any[] = [
        { value: '10', label: '10문항' },
        { value: '20', label: '20문항' },
        { value: '100', label: '100문항' },
        { value: 'all', label: '전체 987문항' }
    ];
    public difficultyOptions: any[] = [
        { value: 'ALL', label: '전체 난이도' },
        { value: 'Easy', label: 'Easy' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Hard', label: 'Hard' },
        { value: '미제공', label: '미제공' }
    ];
    public sourceOptions: any[] = [
        { value: 'ALL', label: '전체 출처' },
        { value: 'Expert', label: 'Expert' },
        { value: 'ResearchGate', label: 'ResearchGate' },
        { value: 'ChatGPT', label: 'ChatGPT' },
        { value: '미제공', label: '미제공' }
    ];
    public statusOptions: any[] = [
        { value: 'ALL', label: '전체 상태' },
        { value: 'SCORED', label: '성공' },
        { value: 'FAILED', label: '실패' }
    ];
    public metrics: any[] = [
        { key: 'clarity_directness', label: 'C&D', title: 'Clarity and Directness' },
        { key: 'practicality_usability', label: 'PIU', title: 'Practicality and Immediate Usability' },
        { key: 'efficiency_brevity', label: 'E&B', title: 'Efficiency and Brevity' },
        { key: 'logical_flow_coherence', label: 'LFC', title: 'Logical Flow and Coherence' },
        { key: 'expert_communication', label: 'EEC', title: 'Expert-to-Expert Communication' },
        { key: 'examples_specificity', label: 'UES', title: 'Use of Examples and Specificity' }
    ];
    public scoreValues: number[] = [1, 2, 3, 4, 5];
    public rubricOptions: any[] = [
        {
            id: 'paper',
            label: '기본 Rubric (공통 척도)',
            description: '6개 기준에 공통 1~5점 척도를 적용합니다.'
        }
    ];
    public generatorOptions: any[] = [
        {
            name: 'gemma4:26b-a4b-it-q8_0',
            label: 'Gemma4 26B',
            description: '기존 SemiKong 기준 모델 · 25.8B · Q8_0',
            available: false
        },
        {
            name: 'qwen3.8:27b',
            label: 'Qwen 3.8 27B',
            description: 'FAB-Bench 공용 Ollama 모델 · 27.3B · Q4_K_M',
            available: false
        }
    ];

    public selectedScope: string = '10';
    public selectedRubricId: string = 'paper';
    public selectedGeneratorModel: string = 'gemma4:26b-a4b-it-q8_0';
    public selectedGeneratorRunId: string = '';
    public selectedDifficulty: string = 'ALL';
    public selectedSource: string = 'ALL';
    public selectedStatus: string = 'ALL';
    public selectedResult: any = null;
    public selectedRunId: string = '';
    public loading: boolean = true;
    public actionRunning: boolean = false;
    public loopRunning: boolean = false;
    public error: string = '';
    public notice: string = '';
    public importDocument: any = null;
    public importFileName: string = '';
    public importCount: number = 0;
    public importError: string = '';
    public dataset: any = {
        question_count: 0,
        unique_question_count: 0,
        duplicate_question_rows: 0,
        difficulty_counts: {},
        source_counts: {},
        difficulty_metadata_present: false,
        source_metadata_present: false
    };
    public config: any = {
        generator_model: 'gemma4:26b-a4b-it-q8_0',
        generator_models: [],
        judge_model: 'gpt-4o-2024-08-06',
        api_key_configured: false,
        default_rubric_id: 'paper',
        rubrics: [],
        scoring_version: ''
    };
    public generator: any = {
        online: false,
        model_available: false,
        model: 'gemma4:26b-a4b-it-q8_0',
        models: []
    };
    public runs: any[] = [];
    public run: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.loadOverview();
    }

    public async loadOverview() {
        if (this.loopRunning) return;
        this.loading = true;
        this.error = '';
        await this.service.render();
        const response: any = await wiz.call('overview');
        if (response && response.code === 200) {
            this.dataset = response.data.dataset || this.dataset;
            this.config = response.data.config || this.config;
            this.rubricOptions = Array.isArray(this.config.rubrics) && this.config.rubrics.length
                ? this.config.rubrics
                : this.rubricOptions;
            if (!this.rubricOptions.some((item: any) => item.id === this.selectedRubricId)) {
                this.selectedRubricId = this.config.default_rubric_id || this.rubricOptions[0].id;
            }
            this.generator = response.data.generator || this.generator;
            const liveModels = Array.isArray(this.generator.models) ? this.generator.models : [];
            const configuredModels = Array.isArray(this.config.generator_models)
                ? this.config.generator_models
                : [];
            if (liveModels.length) {
                this.generatorOptions = liveModels;
            } else if (configuredModels.length) {
                this.generatorOptions = configuredModels.map((item: any) => {
                    return Object.assign({}, item, { available: false });
                });
            } else {
                // A hot deployment can briefly pair the new UI with the legacy
                // overview response, which only reports one model's availability.
                this.generatorOptions = this.generatorOptions.map((item: any) => {
                    const isReportedModel = item.name === this.generator.model;
                    return Object.assign({}, item, {
                        available: isReportedModel && !!this.generator.model_available
                    });
                });
            }
            if (!this.generatorOptions.some((item: any) => item.name === this.selectedGeneratorModel)) {
                this.selectedGeneratorModel = this.config.generator_model || this.generatorOptions[0].name;
            }
            this.runs = response.data.runs || [];
            this.run = response.data.latest_run || null;
            this.selectedRunId = this.run ? this.run.run_id : '';
            this.notice = this.metadataNotice();
        } else {
            this.error = this.errorMessage(response, 'SemiKong 평가 현황을 불러오지 못했습니다.');
        }
        this.loading = false;
        await this.service.render();
    }

    public async startEvaluation() {
        if (!this.canStart()) return;
        this.actionRunning = true;
        this.error = '';
        this.notice = '';
        this.selectedResult = null;
        await this.service.render();
        const response: any = await wiz.call('start', {
            limit: this.selectedScope,
            rubric_id: this.selectedRubricId,
            generator_model: this.selectedGeneratorModel
        });
        if (response && response.code === 200) {
            this.run = response.data.run;
            this.selectedRunId = this.run.run_id;
            this.upsertRunSummary(this.run);
            this.notice = '새 평가 실행을 시작했습니다.';
        } else {
            this.error = this.errorMessage(response, 'SemiKong 평가를 시작하지 못했습니다.');
        }
        this.actionRunning = false;
        await this.service.render();
        if (this.run && this.run.status === 'RUNNING') await this.processRun();
    }

    public async selectJsonFile(event: any) {
        this.importDocument = null;
        this.importFileName = '';
        this.importCount = 0;
        this.importError = '';
        const files = event && event.target ? event.target.files : null;
        if (!files || !files.length) {
            await this.service.render();
            return;
        }
        const file = files.item(0);
        if (Number(file.size || 0) > 30 * 1024 * 1024) {
            this.importError = 'JSON 파일은 최대 30MB까지 불러올 수 있습니다.';
            await this.service.render();
            return;
        }
        try {
            const document = JSON.parse(await this.readFileText(file));
            const rows = this.importRows(document);
            if (!rows.length) throw new Error('평가할 결과 배열이 비어 있습니다.');
            if (rows.length > 2000) throw new Error('한 번에 최대 2,000문항까지 평가할 수 있습니다.');
            rows.forEach((row: any, index: number) => {
                if (!row || typeof row !== 'object') {
                    throw new Error((index + 1) + '번째 문항은 JSON 객체여야 합니다.');
                }
                const question = this.firstText(row, ['question', 'prompt']);
                const answer = this.firstText(row, [
                    'answer', 'gemma_answer', 'model_answer', 'generated_answer', 'response'
                ]);
                if (!question) throw new Error((index + 1) + '번째 문항에 question이 없습니다.');
                if (!answer) throw new Error((index + 1) + '번째 문항에 answer가 없습니다.');
            });
            this.importDocument = document;
            this.importFileName = String(file.name || 'import.json');
            this.importCount = rows.length;
        } catch (parseError) {
            this.importError = this.thrownErrorMessage(parseError, '선택한 JSON을 읽지 못했습니다.');
        }
        await this.service.render();
    }

    public async startJsonEvaluation() {
        if (!this.canStartJsonEvaluation()) return;
        this.actionRunning = true;
        this.error = '';
        this.notice = '';
        this.selectedResult = null;
        await this.service.render();
        const response: any = await wiz.call('import_run', {
            document: JSON.stringify(this.importDocument),
            source_filename: this.importFileName,
            rubric_id: this.selectedRubricId
        });
        if (response && response.code === 200) {
            this.run = response.data.run;
            this.selectedRunId = this.run.run_id;
            this.upsertRunSummary(this.run);
            this.notice = this.importCount + '개 저장 답변을 불러와 Judge 평가를 시작했습니다.';
        } else {
            this.error = this.errorMessage(response, 'JSON 평가를 시작하지 못했습니다.');
        }
        this.actionRunning = false;
        await this.service.render();
        if (this.run && this.run.status === 'RUNNING') await this.processRun();
    }

    public async startSavedRunRejudge() {
        if (!this.canStartSavedRunRejudge()) return;
        const source = this.reusableRuns().find(
            (item: any) => item.run_id === this.selectedGeneratorRunId
        );
        this.actionRunning = true;
        this.error = '';
        this.notice = '';
        this.selectedResult = null;
        await this.service.render();
        const response: any = await wiz.call('rejudge_saved_run', {
            source_run_id: this.selectedGeneratorRunId,
            rubric_id: this.selectedRubricId
        });
        if (response && response.code === 200) {
            this.run = response.data.run;
            this.selectedRunId = this.run.run_id;
            this.upsertRunSummary(this.run);
            this.notice = Number((source || {}).reusable_answer_count || 0)
                + '개 기존 생성 답변을 불러와 Judge 재평가를 시작했습니다.';
        } else {
            this.error = this.errorMessage(response, '저장된 생성 답변 재평가를 시작하지 못했습니다.');
        }
        this.actionRunning = false;
        await this.service.render();
        if (this.run && this.run.status === 'RUNNING') await this.processRun();
    }

    public async processRun() {
        if (!this.run || this.loopRunning || this.run.status !== 'RUNNING') return;
        this.loopRunning = true;
        this.error = '';
        await this.service.render();
        while (this.run && this.run.status === 'RUNNING') {
            let response: any;
            try {
                response = await wiz.call('evaluate_next', { run_id: this.run.run_id });
            } catch (requestError) {
                this.error = '네트워크 오류로 평가가 일시중단되었습니다. 재개 버튼을 눌러주세요.';
                break;
            }
            if (!response || response.code !== 200) {
                this.error = this.errorMessage(response, '문항 평가 요청이 실패했습니다.');
                break;
            }
            this.run = response.data.run;
            this.upsertRunSummary(this.run);
            await this.service.render();
        }
        this.loopRunning = false;
        if (this.run && this.run.status === 'COMPLETED') {
            this.notice = this.run.summary.completed + '문항 평가가 완료되었습니다.';
        } else if (this.run && this.run.status === 'PAUSED') {
            this.notice = '완료된 결과를 보존하고 평가를 중지했습니다.';
        }
        await this.service.render();
    }

    public async pauseEvaluation() {
        if (!this.run || this.run.status !== 'RUNNING' || this.actionRunning) return;
        this.actionRunning = true;
        this.notice = '현재 처리 중인 한 문항이 끝나면 중지합니다.';
        await this.service.render();
        const response: any = await wiz.call('pause', { run_id: this.run.run_id });
        if (response && response.code === 200) {
            this.run = response.data.run;
            this.upsertRunSummary(this.run);
        } else {
            this.error = this.errorMessage(response, '평가를 중지하지 못했습니다.');
        }
        this.actionRunning = false;
        await this.service.render();
    }

    public async resumeEvaluation() {
        if (!this.canResume()) return;
        this.actionRunning = true;
        this.error = '';
        await this.service.render();
        const response: any = await wiz.call('resume', { run_id: this.run.run_id });
        if (response && response.code === 200) {
            this.run = response.data.run;
            this.upsertRunSummary(this.run);
            this.notice = '저장된 다음 문항부터 평가를 재개합니다.';
        } else {
            this.error = this.errorMessage(response, '평가를 재개하지 못했습니다.');
        }
        this.actionRunning = false;
        await this.service.render();
        if (this.run && this.run.status === 'RUNNING') await this.processRun();
    }

    public async loadRun() {
        if (!this.selectedRunId || this.loopRunning || this.actionRunning) return;
        this.actionRunning = true;
        this.error = '';
        this.selectedResult = null;
        await this.service.render();
        const response: any = await wiz.call('load_run', { run_id: this.selectedRunId });
        if (response && response.code === 200) {
            this.run = response.data.run;
            this.notice = '저장된 실행 결과를 불러왔습니다.';
        } else {
            this.error = this.errorMessage(response, '저장된 실행을 불러오지 못했습니다.');
        }
        this.actionRunning = false;
        await this.service.render();
    }

    public async loadSavedRun(runId: string) {
        this.selectedRunId = runId;
        await this.loadRun();
    }

    public canStart() {
        return !this.loading && !this.actionRunning && !this.loopRunning
            && (!this.run || this.run.status !== 'RUNNING')
            && this.config.api_key_configured && this.generatorModelAvailable();
    }

    public canResume() {
        return this.run && this.run.status !== 'COMPLETED'
            && !this.loopRunning && !this.actionRunning
            && this.config.api_key_configured
            && (this.isJudgeOnlyRun(this.run)
                || this.generatorModelAvailable(this.run.generator_model));
    }

    public canStartJsonEvaluation() {
        return !!this.importDocument && this.importCount > 0
            && !this.loading && !this.actionRunning && !this.loopRunning
            && (!this.run || this.run.status !== 'RUNNING')
            && this.config.api_key_configured;
    }

    public canStartSavedRunRejudge() {
        return !!this.selectedGeneratorRunId
            && this.reusableRuns().some((item: any) => item.run_id === this.selectedGeneratorRunId)
            && !this.loading && !this.actionRunning && !this.loopRunning
            && (!this.run || this.run.status !== 'RUNNING')
            && this.config.api_key_configured;
    }

    public reusableRuns() {
        return this.runs.filter((item: any) => {
            return (item.run_type || 'GENERATE_AND_JUDGE') === 'GENERATE_AND_JUDGE'
                && item.status !== 'RUNNING'
                && Number(item.reusable_answer_count || 0) > 0;
        });
    }

    public results() {
        return this.run && Array.isArray(this.run.results) ? this.run.results : [];
    }

    public filteredResults() {
        return this.results().filter((result: any) => {
            const difficulty = this.difficultyGroup(result.difficulty);
            const source = this.sourceGroup(result.source);
            if (this.selectedDifficulty !== 'ALL' && difficulty !== this.selectedDifficulty) return false;
            if (this.selectedSource !== 'ALL' && source !== this.selectedSource) return false;
            if (this.selectedStatus === 'SCORED' && result.status !== 'SCORED') return false;
            if (this.selectedStatus === 'FAILED' && result.status === 'SCORED') return false;
            return true;
        });
    }

    public difficultyRows() {
        return ['Easy', 'Medium', 'Hard', '미제공'].map((group: string) => {
            return Object.assign({ group: group }, this.groupSummary('by_difficulty', group));
        });
    }

    public sourceRows() {
        return ['Expert', 'ResearchGate', 'ChatGPT', '미제공'].map((group: string) => {
            return Object.assign({ group: group }, this.groupSummary('by_source', group));
        });
    }

    public summary() {
        return this.run && this.run.summary ? this.run.summary : {
            target: 0,
            completed: 0,
            scored: 0,
            failed: 0,
            progress_percent: 0,
            metric_averages: {},
            score_distributions: {},
            total_average: 0,
            overall_average: 0,
            by_difficulty: {},
            by_source: {},
            openai_usage: {}
        };
    }

    public openAIUsage() {
        return this.summary().openai_usage || {
            api_request_count: 0,
            input_tokens: 0,
            cached_input_tokens: 0,
            output_tokens: 0,
            total_tokens: 0,
            estimated_cost_usd: 0,
            cached_token_data_complete: true
        };
    }

    public progressPercent() {
        return Number(this.summary().progress_percent || 0);
    }

    public score(result: any, metric: string) {
        const value = result && result.scores ? result.scores[metric] : null;
        return value === undefined ? null : value;
    }

    public reason(result: any, metric: string) {
        return result && result.reasons ? result.reasons[metric] || '' : '';
    }

    public average(metric: string) {
        return Number((this.summary().metric_averages || {})[metric] || 0).toFixed(2);
    }

    public scoreDistributionRows() {
        const distributions = this.summary().score_distributions || {};
        return this.metrics.map((metric: any) => {
            const stored = distributions[metric.key] || {};
            const counts: any = {};
            this.scoreValues.forEach((score: number) => {
                counts[score] = Number(stored[String(score)] || stored[score] || 0);
            });
            return Object.assign({}, metric, {
                counts: counts,
                total: this.scoreValues.reduce(
                    (sum: number, score: number) => sum + counts[score],
                    0
                )
            });
        });
    }

    public downloadScoreDistributionCsv() {
        if (!this.run || Number(this.summary().scored || 0) <= 0) return;
        const rows: any[][] = [
            ['실행 ID', this.run.run_id || ''],
            ['실행 유형', this.runTypeLabel(this.run)],
            ['채점 성공 문항', Number(this.summary().scored || 0)],
            [],
            ['평가 기준', '설명', '1점', '2점', '3점', '4점', '5점', '합계']
        ];
        this.scoreDistributionRows().forEach((row: any) => {
            rows.push([
                row.label,
                row.title,
                row.counts[1],
                row.counts[2],
                row.counts[3],
                row.counts[4],
                row.counts[5],
                row.total
            ]);
        });
        const csv = '\uFEFF' + rows
            .map((row: any[]) => row.map((value: any) => this.csvCell(value)).join(','))
            .join('\r\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'semikong_score_distribution_' + String(this.run.run_id || 'current') + '.csv';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    }

    public async selectResult(result: any) {
        this.selectedResult = result;
        await this.service.render();
    }

    public async closeResultDetails() {
        this.selectedResult = null;
        await this.service.render();
    }

    public metadataLabel(value: any) {
        return value === null || value === undefined || String(value).trim() === ''
            ? '미제공'
            : String(value);
    }

    public difficultyGroup(value: any) {
        const normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'easy') return 'Easy';
        if (normalized === 'medium') return 'Medium';
        if (normalized === 'hard') return 'Hard';
        return '미제공';
    }

    public sourceGroup(value: any) {
        const normalized = String(value || '').trim().toLowerCase().replace(/[^a-z]/g, '');
        if (['expert', 'internalexpert', 'companyexpert'].indexOf(normalized) >= 0) return 'Expert';
        if (normalized === 'researchgate') return 'ResearchGate';
        if (normalized === 'chatgpt') return 'ChatGPT';
        return '미제공';
    }

    public statusLabel(status: string) {
        if (status === 'RUNNING') return '실행 중';
        if (status === 'PAUSED') return '중지됨';
        if (status === 'COMPLETED') return '완료';
        if (status === 'SCORED') return '성공';
        return '실패';
    }

    public statusClass(status: string) {
        if (status === 'COMPLETED' || status === 'SCORED') return 'bg-emerald-50 text-emerald-700';
        if (status === 'RUNNING') return 'bg-cyan-50 text-cyan-700';
        if (status === 'PAUSED') return 'bg-amber-50 text-amber-700';
        return 'bg-rose-50 text-rose-700';
    }

    public formatDate(value: string) {
        return value ? new Date(value).toLocaleString('ko-KR') : '-';
    }

    public formatDuration(value: any) {
        const milliseconds = Number(value || 0);
        return milliseconds ? (milliseconds / 1000).toFixed(1) + '초' : '-';
    }

    public formatInteger(value: any) {
        return Number(value || 0).toLocaleString('ko-KR');
    }

    public formatCost(value: any) {
        return '$' + Number(value || 0).toFixed(6);
    }

    public resultOriginLabel(result: any) {
        if (result && result.input_origin === 'imported_json') return 'JSON 가져오기';
        if (result && result.input_origin === 'saved_gemma_run') return '기존 생성 답변 재사용';
        return this.generatorModelLabel(result && result.generator_model) + ' 생성';
    }

    public resultAnswerTitle(result: any) {
        if (result && result.input_origin === 'imported_json') return '가져온 JSON 답변';
        if (result && result.input_origin === 'saved_gemma_run') {
            return '재사용한 ' + this.generatorModelLabel(result.generator_model) + ' 답변';
        }
        return this.generatorModelLabel(result && result.generator_model) + ' 답변';
    }

    public referenceAnswer(result: any) {
        if (result && result.reference_answer) return String(result.reference_answer);
        return result && result.input_origin === 'imported_json'
            ? '가져온 JSON에 정답 또는 기준 답안이 제공되지 않았습니다.'
            : '공개 SemiKong 데이터셋에 정답이 제공되지 않았습니다.';
    }

    public judgeMetrics(result: any) {
        return result && result.metrics && result.metrics.judge
            ? result.metrics.judge
            : {};
    }

    public formatJson(value: any) {
        try {
            return JSON.stringify(value || {}, null, 2);
        } catch (error) {
            return '{}';
        }
    }

    public isImportedRun(run: any) {
        return !!run && run.run_type === 'JSON_JUDGE_ONLY';
    }

    public isJudgeOnlyRun(run: any) {
        return !!run && ['JSON_JUDGE_ONLY', 'SAVED_GEMMA_JUDGE_ONLY'].indexOf(run.run_type) >= 0;
    }

    public runTypeLabel(run: any) {
        if (this.isImportedRun(run)) return 'JSON Judge';
        if (run && run.run_type === 'SAVED_GEMMA_JUDGE_ONLY') return '기존 생성 답변 재평가';
        return this.generatorModelLabel(run && run.generator_model) + ' 생성+Judge';
    }

    public rubricLabel(run: any) {
        if (run && run.rubric_label) return String(run.rubric_label);
        const rubricId = run && run.rubric_id ? run.rubric_id : 'paper';
        const option = this.rubricOptions.find((item: any) => item.id === rubricId);
        return option ? option.label : '기본 Rubric (공통 척도)';
    }

    public selectedRubricDescription() {
        const option = this.rubricOptions.find((item: any) => item.id === this.selectedRubricId);
        return option ? option.description || '' : '';
    }

    public generatorModelAvailable(modelName?: string) {
        const requested = modelName || this.selectedGeneratorModel;
        const option = this.generatorOptions.find((item: any) => item.name === requested);
        return !!(option && option.available);
    }

    public generatorModelLabel(modelName?: string) {
        const requested = modelName || this.selectedGeneratorModel;
        const option = this.generatorOptions.find((item: any) => item.name === requested);
        if (option && option.label) return String(option.label);
        if (requested === 'qwen3.8:27b') return 'Qwen 3.8 27B';
        return 'Gemma4 26B';
    }

    public selectedGeneratorDescription() {
        const option = this.generatorOptions.find(
            (item: any) => item.name === this.selectedGeneratorModel
        );
        return option ? option.description || '' : '';
    }

    public trackResult(index: number, result: any) {
        return result.id;
    }

    private groupSummary(dimension: string, group: string) {
        const groups = this.summary()[dimension] || {};
        return groups[group] || {
            completed: 0,
            scored: 0,
            failed: 0,
            metric_averages: {},
            score_distributions: {},
            total_average: 0,
            overall_average: 0
        };
    }

    private metadataNotice() {
        if (!this.dataset.difficulty_metadata_present && !this.dataset.source_metadata_present) {
            return '공개 CSV에는 난이도·출처 열이 없어 987문항 모두 “미제공”으로 보존했습니다.';
        }
        return '';
    }

    private upsertRunSummary(run: any) {
        if (!run) return;
        const summary = run.summary || {};
        const item = {
            run_id: run.run_id,
            status: run.status,
            created_at: run.created_at,
            updated_at: run.updated_at,
            completed_at: run.completed_at,
            target_count: run.target_count,
            completed_count: summary.completed || 0,
            scored_count: summary.scored || 0,
            failed_count: summary.failed || 0,
            progress_percent: summary.progress_percent || 0,
            run_type: run.run_type || 'GENERATE_AND_JUDGE',
            source_filename: run.source_filename || '',
            source_run_id: run.source_run_id || '',
            rubric_id: run.rubric_id || 'paper',
            rubric_label: run.rubric_label || '',
            scoring_version: run.scoring_version || '',
            generator_model: run.generator_model || this.selectedGeneratorModel,
            reusable_answer_count: (run.results || []).filter((row: any) => {
                return !!String(row.question || '').trim() && !!String(row.answer || '').trim();
            }).length,
            total_average: summary.total_average || 0,
            openai_api_calls: (summary.openai_usage || {}).api_request_count || 0,
            openai_total_tokens: (summary.openai_usage || {}).total_tokens || 0,
            estimated_cost_usd: (summary.openai_usage || {}).estimated_cost_usd || 0
        };
        this.runs = [item].concat(this.runs.filter((row: any) => row.run_id !== run.run_id));
    }

    private errorMessage(response: any, fallback: string) {
        if (response && response.data && response.data.message) return response.data.message;
        if (response && response.message) return response.message;
        return fallback;
    }

    private csvCell(value: any) {
        const text = String(value === null || value === undefined ? '' : value);
        return '"' + text.replace(/"/g, '""') + '"';
    }

    private importRows(document: any) {
        if (Array.isArray(document)) return document;
        if (!document || typeof document !== 'object') {
            throw new Error('JSON 최상위 값은 배열 또는 객체여야 합니다.');
        }
        for (const key of ['results', 'items', 'data']) {
            if (Array.isArray(document[key])) return document[key];
        }
        throw new Error('JSON에 results, items 또는 data 배열이 없습니다.');
    }

    private firstText(row: any, keys: string[]) {
        for (const key of keys) {
            if (typeof row[key] === 'string' && row[key].trim()) return row[key].trim();
        }
        return '';
    }

    private readFileText(file: any): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(new Error('파일 읽기에 실패했습니다.'));
            reader.readAsText(file, 'utf-8');
        });
    }

    private thrownErrorMessage(error: any, fallback: string) {
        return error && error.message ? String(error.message) : fallback;
    }
}

export default PageSemikongEvaluationComponent;